import WindBaseStyles from './WindBaseStyles';
export { default as AirTemperature } from './AirTemperatureStyles';
export { default as Currents } from './CurrentsStyles';
export { default as CurrentsKts } from './CurrentsStyles';
export { default as DewPoint } from './DewPointStyles';
export { default as FreezingLevel } from './FreezingLevelStyles';
export { default as HighLowPressureSymbols } from './HighLowPressureSymbolsStyles';
export { default as HPa500 } from './HPa500Styles';
export { default as Hurricanes } from './HurricanesStyles';
export { default as IceBergPosition } from './IceBergPositionStyles';
export { default as IceConcentration } from './IceConcentrationStyles';
export { default as MaxIceConcentration } from './MaxIceConcentrationStyles';
export { default as Icing } from './IcingStyles';
export { default as Precipitation } from './PrecipitationStyles';
export { default as Pressure } from './PressureStyles';
export { default as RelativeHumidity } from './RelativeHumidityStyles';
export { default as RiskWaveHeight } from './RiskWaveHeightStyles';
export { default as RiskWindSpeed } from './RiskWindSpeedStyles';
export { default as RiskWindSpeedKts } from './RiskWindSpeedStyles';
export { default as SeaWaterDensity } from './SeaWaterDensityStyles';
export { default as SeaWaterSalinity } from './SeaWaterSalinityStyles';
export { default as SeaWaterTemperature } from './SeaWaterTemperatureStyles';
export { default as Swell } from './SwellStyles';
export { default as SwellPeriod } from './SwellPeriodStyles';
export { default as Visibility } from './VisibilityStyles';
export { default as Wave } from './WaveStyles';
export { default as WeatherCode } from './WeatherCodeStyles';
export { default as WavePeriod } from './WavePeriodStyles';
export { default as WeatherFrontData } from './WeatherFrontDataStyles';
export { default as WindGusts10M } from './WindGusts10MStyles';
export { default as WindGusts50M } from './WindGusts50MStyles';
export { default as WindGusts10MKts } from './WindGusts10MStyles';
export { default as WindGusts50MKts } from './WindGusts50MStyles';
export { default as PortsPilots } from './PortsPilotsStyles';
export { default as LegsViapoints } from './LegsViapointsStyles';
export { default as SeaWaterDynamicViscosity } from './SeaWaterDynamicViscosityStyles';
export const Wind10M = WindBaseStyles;
export const Wind30M = WindBaseStyles;
export const Wind50M = WindBaseStyles;
export const Wind10MKts = WindBaseStyles;
export const Wind30MKts = WindBaseStyles;
export const Wind50MKts = WindBaseStyles;